// Default state
export const DEFAULT_STATE = {
  isFetching: true,
  isError: false,
  response: {},
};
export const DEFAULT_STATE_FF_EF = {
  isFetching: false,
  isError: false,
  response: {},
};
export const DEFAULT_STATE_FF_ET = {
  isFetching: false,
  isError: true,
  response: {},
};

// redux state to toggle menu items
export const sidebarToggleItems = {
  users: false,
  bookings: false,
  operatorTrips: false,
  drivers: false,
  customers: false,
  taxidaUsers: false,
  invoice: false,
  fare: false,
  operators: false,
};

export const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const priceTypes = {
  1: "Flat",
  2: "Percentage",
};

export const priceType = [
  {
    label: "Select",
    value: "",
  },
  { label: "Flat", value: "flat" },
  { label: "Percentage", value: "percentage" },
];
export const computeBy = [
  {
    label: "Select",
    value: "",
  },
  { label: "Increase", value: "increase" },
  { label: "Decrease", value: "decrease" },
];
export const paymentPercentage = [
  { label: "Full", value: 100 },
  { label: "10%", value: 10 },
  { label: "Cash", value: 0 },
  { label: "Account", value: "account" },
];
export const advancePercentage = 10;

export const bookingType = {
  outstation: "One way",
  round: "Round trip",
  multiCity: "Multi-stop",
  hourlyRental: "Hourly rental",
  airport: "Airport transfer",
};
export const bookingTypeFilter = {
  outstation: "One way",
  roundTrip: "Round trip",
  multiCity: "Multicity",
  hourlyRental: "Package",
};
export const multicityDuration = [
  { label: "00:30", value: 30 },
  { label: "01:00", value: 60 },
  { label: "01:30", value: 90 },
  { label: "02:00", value: 120 },
  { label: "02:30", value: 150 },
  { label: "03:00", value: 180 },
  { label: "03:30", value: 210 },
  { label: "04:00", value: 240 },
  { label: "04:30", value: 270 },
  { label: "05:00", value: 300 },
  { label: "05:30", value: 330 },
  { label: "06:00", value: 360 },
];
export const packageDuration = [
  { label: "1 hr 10 Kms", value: 60 },
  { label: "2 hrs 20Kms", value: 120 },
  { label: "3 hrs 30 Kms", value: 180 },
  { label: "4 hrs 40 Kms", value: 240 },
  { label: "5 hrs 50 Kms", value: 300 },
  { label: "6 hrs 60 Kms", value: 360 },
  { label: "7 hrs 70 Kms", value: 420 },
  { label: "8 hrs 80 Kms", value: 480 },
  { label: "9 hrs 90 Kms", value: 540 },
  { label: "10 hrs 100 Kms", value: 600 },
  { label: "11 hrs 110 Kms", value: 660 },
  { label: "12 hrs 120 Kms", value: 720 },
];
export const subscriptionTypes = {
  subscription: "Subscription",
  perRide: "Per ride",
};
export const bidExpiryType = {
  fromNow: "From now",
  beforePickup: "Before pickup time",
};

export const TIME_FORMAT_TO_SHOW = "HH:mm";
export const DATE_FORMAT_TO_SHOW = "DD-MM-YYYY";
export const OTP_RESEND_INTERVAL = 90; //time in seconds

export const subscriptionPriceTypes = {
  subscription: {
    bucket: "Bucket",
    flat: "Flat",
  },
  perRide: {
    flat: "Flat",
    percentage: "Percentage",
  },
};
export const rideTypes = {
  pickup: "Pickup",
  dropoff: "Drop",
  both: "Pickup and Drop",
  any: "Pickup or Drop",
};

export const operatingRideTypes = {
  pickup: "Pickup",
  dropoff: "Drop",
  both: "Pickup and Drop",
  any: "Pickup or Drop",
};

export const operatingTripTypes = {
  outstation: "Outstation",
  local: "Local",
};

export const bookingStatus = {
  1: "Pending",
  // 2: "Accepted", // there is no accepted status for now
  3: "Assigned",
  4: "Driver Accepted",
  5: "Driver Rejected",
  6: "En Route To Pickup",
  7: "Arrived",
  8: "On Trip",
  9: "Cancelled",
  10: "Completed",
  11: "On Bid",
};

export const bgColors = {
  1: "bg-lred",
  2: "bg-yellow",
  3: "bg-grn",
  4: "bg-grey",
  5: "bg-dred",
  6: "bg-blu",
  7: "bg-yellow",
  8: "bg-lgrn",
  9: "bg-lgrey",
  10: "bg-sail",
  11: "bg-grey",
  12: "bg-lgrey",
  14: "bg-dred",
  15: "bg-grn",
  16: "bg-grn",
  17: "bg-mauve",
};

export const bgColorsB2c = {
  1: "bg-yellow",
  4: "bg-grey",

  6: "bg-blu",
  7: "bg-yellow",
  8: "bg-lgrey",
  9: "bg-grey",
  10: "bg-sail",
};
export const bgColorsEts = {
  3: "bg-yellow",
  6: "bg-grey",

  7: "bg-blu",
  8: "bg-yellow",
  9: "bg-lgrey",
  10: "bg-sail",
  11: "bg-grey",
};

export const b2CBookingStatus = {
  1: "Pending for driver assign",

  4: "Driver Accepted",

  6: "En Route To Pickup",
  7: "Driver arrived",
  8: "On Trip",
  9: "Cancelled",
  10: "Completed",
};
export const etstripBookingStatus = {
  3: "Pending for driver assign",

  6: "Driver Accepted",

  7: "En Route To Pickup",
  8: "Driver arrived",
  9: "On Trip",
  10: "Completed",
  11: "Cancelled",
};

export const b2btripBookingStatus = {
  2: "Pending for driver assign",

  3: "Driver Assigned",
  4: "Driver Accepted",
  5: "Driver Rejected",
  6: "En Route To Pickup",
  7: "Driver Arrived",
  8: "On Trip-Empty",
  9: "On Trip",
  10: "Completed",
  11: "Cancelled",
  12: "Pending for approval",
  14: "Fare Requested",
  15: "Taxida verified",
  16: "Invoiced",
  17: "Customer No Show",
};

export const b2bBookingStatus = {
  1: "Pending for driver assign",
  2: "Operator Assigned",
  3: "Driver Assigned",
  4: "Driver Accepted",
  5: "Driver Rejected",
  6: "En Route To Pickup",
  7: "Driver Arrived",
  8: "On Trip-Empty",
  9: "On Trip",
  10: "Completed",
  11: "Cancelled",
  12: "Pending for approval",
  14: "Fare Requested",
  15: "Taxida verified",
  16: "Invoiced",
  17: "Customer No Show",
};

export const tripTypeStatus = {
  1: "One way",
  2: "Round trip",
  3: "Multicity",
  4: "Package",
};

export const operatorBookingStatus = {
  1: "Pending",
  2: "On Bid",
  3: "Responded",
  4: "Assigned",
};

// user Roles and its labels
export const userRoles = {
  1: "admin",
  2: "subAdmin",
  3: "controller",
  4: "affiliateAgent",
  5: "aggregator",
  6: "businessUser",
  7: "driver",
  8: "customer",
  9: "driverManager",
};
export const userRoleLabels = {
  1: "Admin",
  2: "Sub-admin",
  3: "Controller",
  4: "Affiliate agent",
  5: "Aggregator",
  6: "Business User",
  7: "Driver",
  8: "Customer",
  9: "Driver manager",
};
export const tripType = [
  {
    label: "Select",
    value: "",
  },

  {
    label: "One way",
    value: "oneway",
  },
  {
    label: "Round",
    value: "round",
  },

  { label: "Both", value: "both" },
];

export const driverVehicleTypes = [
  { label: "Hatchback", value: 1 },
  { label: "Sedan", value: 2 },
  { label: "Economy SUV", value: 3 },
  { label: "Premium SUV", value: 4 },
];

export const VehicleTypesB2c = [
  { label: "Sedan", value: 2 },
  { label: "Economy SUV", value: 3 },
  { label: "Premium SUV", value: 4 },
];
export const tripTypes = [
  { label: "Select", value: "" },
  {
    label: "Local",
    value: "local",
  },
  {
    label: "Outstation",
    value: "outstation",
  },

  { label: "Both", value: "both" },
];
export const geofenceType = [
  // {
  //   label: "Select",
  //   value: "",
  // },

  {
    label: "Local",
    value: "local",
  },
];

export const sdAvailability = [
  { label: "Select", value: "" },
  { label: "Active", value: "true" },
  { label: "Inactive", value: "false" },
];

export const vhAvailability = [
  { label: "Select", value: "" },
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];

export const minNotice = [
  { label: "Select", value: "" },
  { label: "15 min", value: 15 },
  { label: "30 min", value: 30 },
  { label: "45 min", value: 45 },
  { label: "1 hr", value: 60 },
  { label: "2 hrs", value: 120 },
  { label: "3 hrs", value: 180 },
  { label: "4 hrs", value: 240 },
  { label: "5 hrs", value: 300 },
  { label: "6 hrs", value: 360 },
  { label: "7 hrs", value: 420 },
  { label: "8 hrs", value: 480 },
  { label: "9 hrs", value: 540 },
  { label: "10 hrs", value: 600 },
  { label: "11 hrs", value: 660 },
  { label: "12 hrs", value: 720 },
  { label: "13 hrs", value: 780 },
  { label: "14 hrs", value: 840 },
  { label: "15 hrs", value: 900 },
  { label: "16 hrs", value: 960 },
  { label: "17 hrs", value: 1020 },
  { label: "18 hrs", value: 1080 },
  { label: "19 hrs", value: 1140 },
  { label: "20 hrs", value: 1200 },
  { label: "21 hrs", value: 1260 },
  { label: "22 hrs", value: 1320 },
  { label: "23 hrs", value: 1380 },
  { label: "24 hrs", value: 1440 },
];

export const filtertripType = [
  {
    label: "Select",
    value: "",
  },

  {
    label: "Outstation trips",
    value: "outstation",
  },
  {
    label: "Local",
    value: "local",
  },
  // {
  //   label: "Multi stops",
  //   value: "multiCity"
  // },
  { label: "Hourly rental", value: "hourlyRental" },
  { label: "Airport transfer", value: "airport" },
];
export const tripFor = [
  { label: "Customer", value: "customer" },
  { label: "Company", value: "company" },
];

export const bookingForReport = [
  { label: "Select", value: "" },
  { label: "My bookings", value: "vendor" },
  { label: "OTA", value: "aggregator" },
  { label: "Corporate", value: "corporate" },
];
export const trip = {
  oneway: "One way",
  round: "Round",
  both: "Both",
};

export const recordStatus = {
  paid: "Paid",
  unpaid: "Unpaid",
  partiallyPaid: "Partial",
};

export const rolePermissions = [
  {
    user: "Admin",
    roleId: 1,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit", "delete", "assign", "broadcast"],
      users: ["create", "edit", "delete"],
      drivers: ["create", "edit", "delete"],
      driverGroup: ["create", "edit", "delete"],
      operators: ["create", "edit", "delete"],
      operatorGroup: ["create", "edit", "delete"],
      fare: ["create", "edit", "delete"],
      commissions: ["create", "edit", "delete"],
      vehicleTypes: ["create", "edit", "delete"],
      taxidaQuotes: ["create", "edit", "delete"],
      statements: ["create", "edit"],
      invoice: ["create", "edit"],
      driverAlert: ["edit", "delete"],
      promoCodes: ["create", "edit", "delete"],
      operatingArea: ["create", "edit", "delete"],
    },
  },
  {
    user: "Sub-admin",
    roleId: 2,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit", "assign", "broadcast"],
      users: ["create"],
      drivers: ["create"],
      driverGroup: ["create"],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
  {
    user: "Controller",
    roleId: 3,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit", "assign", "broadcast"],
      users: [],
      drivers: [],
      driverGroup: [],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
  {
    user: "Affiliate agent",
    roleId: 4,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit"],
      users: [],
      drivers: [],
      driverGroup: [],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
  {
    user: "Business-User",
    roleId: 6,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit"],
      users: [],
      drivers: [],
      driverGroup: [],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
  {
    user: "Affiliate-driver",
    roleId: 7,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit"],
      users: [],
      drivers: [],
      driverGroup: [],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
  {
    user: "Driver manager",
    roleId: 9,
    permissions: {
      dashboard: [],
      bookings: [],
      users: [],
      drivers: ["create", "edit"],
      driverGroup: ["create", "edit"],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
  {
    user: "Operators",
    roleId: 10,
    permissions: {
      dashboard: [],
      bookings: [],
      users: [],
      drivers: ["create", "edit", "delete"],
      driverGroup: ["create", "edit", "delete"],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: [],
    },
  },
];

export const auctoBidDuration = [
  { label: "30mins", value: 30 },
  { label: "1hr", value: 60 },
  { label: "1hr 30mins", value: 90 },
  { label: "2hrs", value: 120 },
  { label: "2hrs 30mins", value: 150 },
  { label: "3hrs", value: 180 },
  { label: "3hrs 30mins", value: 210 },
  { label: "4hrs", value: 240 },
  { label: "4hrs 30mins", value: 270 },
  { label: "5hrs", value: 300 },
  { label: "5hrs 30mins", value: 330 },
  { label: "6hrs", value: 360 },
  { label: "6hrs 30mins", value: 390 },
  { label: "7hrs", value: 420 },
  { label: "7hrs 30mins", value: 450 },
  { label: "8hrs", value: 480 },
  { label: "8hrs 30mins", value: 510 },
  { label: "9hrs", value: 540 },
  { label: "9hrs 30mins", value: 570 },
  { label: "10hrs", value: 600 },
  { label: "10hrs 30mins", value: 630 },
  { label: "11hrs", value: 660 },
  { label: "11hrs 30mins", value: 690 },
  { label: "12hrs", value: 720 },
];

export const auctoConfigTime = [
  { label: "Bid expiry", value: "bidExpiry" },
  { label: "Min time", value: "minTime" },
];

export const minMmNotice = [
  { label: "Select", value: "" },
  { label: "0", value: 0 },
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
  { label: "11", value: 11 },
  { label: "12", value: 12 },
  { label: "13", value: 13 },
  { label: "14", value: 14 },
  { label: "15", value: 15 },
  { label: "16", value: 16 },
  { label: "17", value: 17 },
  { label: "18", value: 18 },
  { label: "19", value: 19 },
  { label: "20", value: 20 },
  { label: "21", value: 21 },
  { label: "22", value: 22 },
  { label: "23", value: 23 },
  { label: "24", value: 24 },
  { label: "25", value: 25 },
  { label: "26", value: 26 },
  { label: "27", value: 27 },
  { label: "28", value: 28 },
  { label: "29", value: 29 },
  { label: "30", value: 30 },
  { label: "31", value: 31 },
  { label: "32", value: 32 },
  { label: "33", value: 33 },
  { label: "34", value: 34 },
  { label: "35", value: 35 },
  { label: "36", value: 36 },
  { label: "37", value: 37 },
  { label: "38", value: 38 },
  { label: "39", value: 39 },
  { label: "40", value: 40 },
  { label: "41", value: 41 },
  { label: "42", value: 42 },
  { label: "43", value: 43 },
  { label: "44", value: 44 },
  { label: "45", value: 45 },
  { label: "46", value: 46 },
  { label: "47", value: 47 },
  { label: "48", value: 48 },
  { label: "49", value: 49 },
  { label: "50", value: 50 },
  { label: "51", value: 51 },
  { label: "52", value: 52 },
  { label: "53", value: 53 },
  { label: "54", value: 54 },
  { label: "55", value: 55 },
  { label: "56", value: 56 },
  { label: "57", value: 57 },
  { label: "58", value: 58 },
  { label: "59", value: 59 },
];

export const minHhNotice = [
  { label: "Select", value: "" },
  { label: "0", value: "0" },
  { label: "1", value: 60 },
  { label: "2", value: 120 },
  { label: "3", value: 180 },
  { label: "4", value: 240 },
  { label: "5", value: 300 },
  { label: "6", value: 360 },
  { label: "7", value: 420 },
  { label: "8", value: 480 },
  { label: "9", value: 540 },
  { label: "10", value: 600 },
  { label: "11", value: 660 },
  { label: "12", value: 720 },
  { label: "13", value: 780 },
  { label: "14", value: 840 },
  { label: "15", value: 900 },
  { label: "16", value: 960 },
  { label: "17", value: 1020 },
  { label: "18", value: 1080 },
  { label: "19", value: 1140 },
  { label: "20", value: 1200 },
  { label: "21", value: 1260 },
  { label: "22", value: 1320 },
  { label: "23", value: 1380 },
  { label: "24", value: 1440 },
];

export const stateList = [
  { value: "AN", label: "Andaman and Nicobar Islands" },
  { value: "AP", label: "Andhra Pradesh" },
  { value: "AR", label: "Arunachal Pradesh" },
  { value: "AS", label: "Assam" },
  { value: "BR", label: "Bihar" },
  { value: "CG", label: "Chandigarh" },
  { value: "CH", label: "Chhattisgarh" },
  { value: "DN", label: "Dadra and Nagar Haveli" },
  { value: "DD", label: "Daman and Diu" },
  { value: "DL", label: "Delhi" },
  { value: "GA", label: "Goa" },
  { value: "GJ", label: "Gujarat" },
  { value: "HR", label: "Haryana" },
  { value: "HP", label: "Himachal Pradesh" },
  { value: "JK", label: "Jammu and Kashmir" },
  { value: "JH", label: "Jharkhand" },
  { value: "KA", label: "Karnataka" },
  { value: "KL", label: "Kerala" },
  { value: "LA", label: "Ladakh" },
  { value: "LD", label: "Lakshadweep" },
  { value: "MP", label: "Madhya Pradesh" },
  { value: "MH", label: "Maharashtra" },
  { value: "MN", label: "Manipur" },
  { value: "ML", label: "Meghalaya" },
  { value: "MZ", label: "Mizoram" },
  { value: "NL", label: "Nagaland" },
  { value: "OR", label: "Odisha" },
  { value: "PY", label: "Puducherry" },
  { value: "PB", label: "Punjab" },
  { value: "RJ", label: "Rajasthan" },
  { value: "SK", label: "Sikkim" },
  { value: "TN", label: "Tamil Nadu" },
  { value: "TS", label: "Telangana" },
  { value: "TR", label: "Tripura" },
  { value: "UP", label: "Uttar Pradesh" },
  { value: "UK", label: "Uttarakhand" },
  { value: "WB", label: "West Bengal" },
];

export const hourNkm = [
  { label: "3hr-30Km", value: "3hr-30Km" },
  { label: "4hr-40km", value: "4hr-40km" },
  { label: "5hr-50km", value: "5hr-50km" },
  { label: "6hr-60km", value: "6hr-60km" },
  { label: "7hr-70km", value: "7hr-70km" },
  { label: "8hr-80km", value: "8hr-80km" },
  { label: "9hr-90km", value: "9hr-90km" },
  { label: "10hr-100km", value: "10hr-100km" },
  { label: "11hr-110km", value: "11hr-110km" },
  { label: "12hr-120km", value: "12hr-120km" },
];

export const minNoticePeriod = [
  { label: "00:15", value: 15 },
  { label: "00:30", value: 30 },
  { label: "00:45", value: 45 },
  { label: "01:00", value: 60 },
  { label: "01:30", value: 90 },
  { label: "02:00", value: 120 },
  { label: "02:30", value: 150 },
  { label: "03:00", value: 180 },
  { label: "04:00", value: 240 },
  { label: "05:00", value: 300 },
  { label: "06:00", value: 360 },
  { label: "07:00", value: 420 },
  { label: "08:00", value: 480 },
  { label: "09:00", value: 540 },
  { label: "10:00", value: 600 },
  { label: "11:00", value: 660 },
  { label: "12:00", value: 720 },
  { label: "13:00", value: 780 },
  { label: "14:00", value: 840 },
  { label: "15:00", value: 900 },
  { label: "16:00", value: 960 },
  { label: "17:00", value: 1020 },
  { label: "18:00", value: 1080 },
  { label: "19:00", value: 1140 },
  { label: "20:00", value: 1200 },
  { label: "21:00", value: 1260 },
  { label: "22:00", value: 1320 },
  { label: "23:00", value: 1380 },
  { label: "24:00", value: 1440 },
];

export const etsVehicleType = [
  {
    label: "SUV",
    value: "SUV",
  },
  {
    label: "Sedan",
    value: "Sedan",
  },
];

export const vehicleType = [
  {
    label: "Sedan",
    value: "Sedan",
  },
  {
    label: "Economy SUV",
    value: "economy SUV",
  },

  {
    label: "Premium SUV",
    value: "premium SUV",
  },
];

export const etsBookingStatus = {
  1: "Queued",
  2: "Pending for Operator Assigned",
  3: "Operator Assigned",
  4: "Driver Assigned",
  5: "Driver Rejected",
  6: "Driver Accepted",
  7: "En Route To Pickup",
  8: "Driver Arrived",
  9: "On Trip",
  10: "Completed",
  11: "Cancelled",
};

export const etsTripType = {
  "Home pickup": "Home pickup",
  "Office pickup": "Office pickup",
};
export const surgeMethod = [
  { label: "Increase", value: "increase" },
  { label: "Decrease", value: "decrease" },
];

export const sdValueType = [
  { label: "Percentage", value: "percentage" },
  { label: "Flat", value: "flat" },
];

export const waitHrs = [
  { label: "1 min", value: 1 },
  { label: "2 Mins", value: 2 },
  { label: "3 Mins", value: 3 },
  { label: "4 Mins", value: 4 },
  { label: "5 Mins", value: 5 },
  { label: "6 Mins", value: 6 },
  { label: "7 Mins", value: 7 },
  { label: "8 Mins", value: 8 },
  { label: "9 Mins", value: 9 },
  { label: "10 Mins", value: 10 },
  { label: "11 Mins", value: 11 },
  { label: "12 Mins", value: 12 },
  { label: "13 Mins", value: 13 },
  { label: "14 Mins", value: 14 },
  { label: "0:15 hr", value: 15 },
  { label: "0:30 hr", value: 30 },
  { label: "0:45 hr", value: 45 },
  { label: "1:00 hr", value: 60 },
  { label: "1:15 hrs", value: 75 },
  { label: "1:30 hrs", value: 90 },
  { label: "1:45 hrs", value: 105 },
  { label: "2:00 hrs", value: 120 },
  { label: "2:15 hrs", value: 135 },
  { label: "2:30 hrs", value: 150 },
  { label: "2:45 hrs", value: 165 },
  { label: "3:00 hrs", value: 180 },
  { label: "3:15 hrs", value: 195 },
  { label: "3:30 hrs", value: 210 },
  { label: "3:45 hrs", value: 225 },
  { label: "4:00 hrs", value: 240 },
  { label: "4:15 hrs", value: 255 },
  { label: "4:30 hrs", value: 270 },
  { label: "4:45 hrs", value: 285 },
  { label: "5:00 hrs", value: 300 },
];
export const tmcStatus = [
  {
    label: "Active",
    value: true,
  },
  {
    label: "Inactive",
    value: false,
  },
];
export const tmcVehicleType = [
  {
    label: "SUV",
    value: 3,
  },
  {
    label: "Sedan",
    value: 2,
  },
];
export const etsEmployeeStatus = [
  {
    label: "To be onboard",
    value: "to be onboard",
  },
  {
    label: "On boarded",
    value: "onboarded",
  },
  {
    label: "Dropped",
    value: "dropped",
  },
  {
    label: "No-show",
    value: "no show",
  },
];
